import React from 'react';
import { GeoJSON } from 'react-leaflet';
import { predictions } from '../data/prediction.js';
import chroma from "chroma-js";

const categories = [
  '10th Percentile',
  '20th Percentile',
  '30th Percentile',
  '40th Percentile',
  '50th Percentile',
  '60th Percentile',
  '70th Percentile',
  '80th Percentile',
  '90th Percentile',
  '100th Percentile'
];

const colorScale = chroma.scale(["#F2F5F3", "#002A11"]).domain([0, categories.length - 1]);

const categoryToColor = categories.reduce((acc, category, index) => {
  acc[category] = colorScale(index).hex();
  return acc;
}, {});

function PopulationPolygon() {
  function getFeatureStyle(feature) {
    const category = feature.properties.population_percentile;
    const color = categoryToColor[category];
  
    return {
      color: "transparent",
      weight: 1.5,
      fillColor: color,
      fillOpacity: 0.4,
    };
  }

  return (
    <GeoJSON data={predictions} style={getFeatureStyle}  />
  );
}

export default PopulationPolygon;


